var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixInterfacesFormsV4SubmissionExtension from '@wix/ambassador-interfaces-forms-v4-submission-extension/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["UNDEFINED"] = "UNDEFINED";
    SubmissionStatus["PENDING"] = "PENDING";
    SubmissionStatus["CONFIRMED"] = "CONFIRMED";
    SubmissionStatus["PAYMENT_WAITING"] = "PAYMENT_WAITING";
    SubmissionStatus["PAYMENT_CANCELED"] = "PAYMENT_CANCELED";
})(SubmissionStatus || (SubmissionStatus = {}));
export var ActionType;
(function (ActionType) {
    ActionType["UNKNOWN_ACTION"] = "UNKNOWN_ACTION";
    ActionType["UPDATE"] = "UPDATE";
    ActionType["CREATE"] = "CREATE";
})(ActionType || (ActionType = {}));
export var SubmissionErrorType;
(function (SubmissionErrorType) {
    /** Error is unknown or not suitable for any of options bellow */
    SubmissionErrorType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    /** Type of submitted value is incorrect */
    SubmissionErrorType["TYPE_ERROR"] = "TYPE_ERROR";
    /** Value is required to be provided */
    SubmissionErrorType["REQUIRED_VALUE_ERROR"] = "REQUIRED_VALUE_ERROR";
    /** Value contains additional properties not expected in schema */
    SubmissionErrorType["UNKNOWN_VALUE_ERROR"] = "UNKNOWN_VALUE_ERROR";
    /** Text value exceeds max length */
    SubmissionErrorType["MAX_LENGTH_ERROR"] = "MAX_LENGTH_ERROR";
    /** Text value not reaches min length */
    SubmissionErrorType["MIN_LENGTH_ERROR"] = "MIN_LENGTH_ERROR";
    /** Text value not applicable for expected pattern */
    SubmissionErrorType["PATTERN_ERROR"] = "PATTERN_ERROR";
    /** Text value not applicable for expected format */
    SubmissionErrorType["FORMAT_ERROR"] = "FORMAT_ERROR";
    /** Number value is too big */
    SubmissionErrorType["MAX_VALUE_ERROR"] = "MAX_VALUE_ERROR";
    /** Number value is too small */
    SubmissionErrorType["MIN_VALUE_ERROR"] = "MIN_VALUE_ERROR";
    /** Number value is not multiple of expected number */
    SubmissionErrorType["MULTIPLE_OF_VALUE_ERROR"] = "MULTIPLE_OF_VALUE_ERROR";
    /** Array value has too much items */
    SubmissionErrorType["MIN_ITEMS_ERROR"] = "MIN_ITEMS_ERROR";
    /** Array value has not enough items */
    SubmissionErrorType["MAX_ITEMS_ERROR"] = "MAX_ITEMS_ERROR";
    /** Value is not in list of allowed values */
    SubmissionErrorType["NOT_ALLOWED_VALUE_ERROR"] = "NOT_ALLOWED_VALUE_ERROR";
    /** Submitted form is disabled */
    SubmissionErrorType["DISABLED_FORM_ERROR"] = "DISABLED_FORM_ERROR";
})(SubmissionErrorType || (SubmissionErrorType = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
const _validateSubmissionRequest = {};
const _validateSubmissionResponse = {};
/**
 * > **Notes:** <br>
 * > - The Form Submission service plugin is only available in Wix Studio and Editor X.
 * > - The Form Submission service plugin only works with the Wix Forms app. Call [GetAppInstance](https://dev.wix.com/docs/rest/api-reference/app-management/apps/app-instance/get-app-instance) to confirm that the app named `wix_forms` is installed on the site.
 * <br>
 * Validates a submission. <br>
 * Validates a site visitor's form submission and returns any validation violations. <br>
 * Site visitors can see the validation violations on their forms. For example, invalid fields are highlighted in red.
 * @public
 * @documentationMaturity preview
 * @requiredField options.actionType
 * @requiredField options.submission
 */
export function validateSubmission(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            submission: '$[0].submission',
            actionType: '$[0].actionType',
            updateOptions: '$[0].updateOptions',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _validateSubmissionRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _validateSubmissionResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixInterfacesFormsV4SubmissionExtension.validateSubmission(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=interfaces-forms-v4-submission-extension.universal.js.map